module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "input"
  }, [_c('h3', {
    staticClass: "input__header"
  }, [_vm._v(_vm._s(_vm.question))]), _c('Range', {
    attrs: {
      "scale": _vm.scale,
      "showScale": _vm.showScale,
      "error": _vm.error
    },
    model: {
      value: (_vm.levelPosition),
      callback: function($$v) {
        _vm.levelPosition = $$v
      },
      expression: "levelPosition"
    }
  }), (_vm.showLeveler) ? _c('Leveler', {
    attrs: {
      "scale": _vm.scale,
      "error": _vm.error
    },
    model: {
      value: (_vm.levelPosition),
      callback: function($$v) {
        _vm.levelPosition = $$v
      },
      expression: "levelPosition"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db28450c","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/formrange/FormRange.vue
// module id = 350e8944cbd06eaebee7
// module chunks = 5